<template>
  <div class="valueListCell">
    <span>{{ subjects.slice(0, 3).join(', ') }}</span>

    <br v-if="values.length > 3">

    <neb-tooltip v-if="values.length > 3"
      :content="subjects.slice(3).join(', ')"
    >
      <a> +{{values.length - 3}} More</a>
    </neb-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ValueListCell',

  props: {
    values: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    subjects () {
      return this.values.map(v => v.subject)
    }
  }
}
</script>

<style lang="scss">
.valueListCell {
  width: 200px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
